import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { shadow } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        size: {
            small: {
                width: 36,
                height: 20,
                borderRadius: 100,
                thumbSize: 16,
                thumbGap: 2,
                thumbIcon: 12,
            },
            medium: {
                width: 44,
                height: 24,
                borderRadius: 100,
                thumbSize: 20,
                thumbGap: 2,
                thumbIcon: 16,
            },
        },
        color: {
            thumb: {
                default: semantic.inverse.global.default,
                disabled: semantic.inverse.global.default,
                icon: semantic.inverse.global.default,
            },
            checked: {
                default: semantic.fill.global.primary,
                hover: semantic.state.primary.hover,
                active: semantic.state.primary.press,
                disabled: semantic.state.subtle.primary.disable,
            },
            unchecked: {
                default: semantic.fill.neutral,
                hover: semantic.state.neutral.hover,
                active: semantic.state.neutral.press,
                disabled: semantic.state.disable,
            },
            label: {
                default: semantic.fill.default,
                disabled: semantic.text.neutral,
            },
        },
        boxShadow: {
            focus: `0 0 0 2px ${semantic.fill.default}, 0 0 0 4px ${semantic.fill.primary}`,
            thumb: shadow.sm,
        },
    };
}
